// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/supplier_profitability_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SupplierProfitabilityItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.SupplierProfitabilityReportRequest
 */
export class SupplierProfitabilityReportRequest extends Message<SupplierProfitabilityReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<SupplierProfitabilityReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierProfitabilityReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierProfitabilityReportRequest {
    return new SupplierProfitabilityReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierProfitabilityReportRequest {
    return new SupplierProfitabilityReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierProfitabilityReportRequest {
    return new SupplierProfitabilityReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierProfitabilityReportRequest | PlainMessage<SupplierProfitabilityReportRequest> | undefined, b: SupplierProfitabilityReportRequest | PlainMessage<SupplierProfitabilityReportRequest> | undefined): boolean {
    return proto3.util.equals(SupplierProfitabilityReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SupplierProfitabilityReportResponse
 */
export class SupplierProfitabilityReportResponse extends Message<SupplierProfitabilityReportResponse> {
  /**
   * List of supplier profitability items
   *
   * @generated from field: repeated com.neulink.pharmacy.SupplierProfitabilityItem supplier_profitability_items = 1;
   */
  supplierProfitabilityItems: SupplierProfitabilityItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<SupplierProfitabilityReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierProfitabilityReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_profitability_items", kind: "message", T: SupplierProfitabilityItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierProfitabilityReportResponse {
    return new SupplierProfitabilityReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierProfitabilityReportResponse {
    return new SupplierProfitabilityReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierProfitabilityReportResponse {
    return new SupplierProfitabilityReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierProfitabilityReportResponse | PlainMessage<SupplierProfitabilityReportResponse> | undefined, b: SupplierProfitabilityReportResponse | PlainMessage<SupplierProfitabilityReportResponse> | undefined): boolean {
    return proto3.util.equals(SupplierProfitabilityReportResponse, a, b);
  }
}

